<template>
  <i18n-t :keypath="'NotificationsComponent.' + notification.type" tag="span" class="pl-quarter" scope="global">
    <template #link>
      <router-link :to="{ name: notification?.params?.url }">{{ t(notificationMessage) }}</router-link>
    </template>
  </i18n-t>
</template>

<script lang="ts">
import { defineComponent, PropType, ref } from "vue";
import { logEvent } from "@/common/logger";
import { t } from "@/i18n";
import { INotification } from "@/stores/notifications";

const componentName = "KeycodeExpiredNotification";

export default defineComponent({
  name: componentName,
  props: {
    notification: {
      type: Object as PropType<INotification>,
      required: true,
    },
  },
  setup(props) {
    logEvent("created", componentName);

    const notificationMessage = ref<string>(props.notification?.params?.text ?? "");
    //Expose to template
    return { t, notificationMessage };
  },
});
</script>
